import { IError, IResponseEvent } from "@core/data-access/model";
import { IErrorConfig, ILogger } from "@core/logger/types";
import { envConfig } from "@env/env-config";
import { IMessageDialogLevel } from "@qpUIs/qp-message-dialog/qp-message-dialog-options.interface";
import { IMessageDialog } from "@qpUIs/qp-message-dialog/qp-message-dialog.interface";


type reqParams<T> = {
    e: IResponseEvent<T>,
    root: string,
    qpMessageDialog: IMessageDialog,
    $injector: angular.auto.IInjectorService,
    // $q: angular.IQService,
    // $translate: angular.translate.ITranslateService,
}

type sendErrParams = {
    $injector: angular.auto.IInjectorService,
}

type openUnhandleErrorMsgDialogParams = {
    $injector: angular.auto.IInjectorService,
}

export function handleReuqestFail<T extends IError>(params: reqParams<T>, needAuthorized: boolean = true): angular.IPromise<T> {
    let $injector = params.$injector;
    let e = params.e;
    
    // TODO: 此处应该只需要传递$injector和error，其他service通过$injector获取
    let $translate = $injector.get<angular.translate.ITranslateService>("$translate");
    let defer = $injector.get<angular.IQService>("$q").defer<T>();
    let $msgDialog = params.qpMessageDialog;
    let rootPath = params.root;
    
    if (e != null && typeof e === "object") {
        //没有访问权限
        if (e.status == 401) {
            if (needAuthorized) {
                // 实名用户处理
                $msgDialog.info({
                    title: $translate.instant("MISSING_AUTHENTICATION_TITLE"),
                    content: $translate.instant("MISSING_AUTHENTICATION_CONTENT"),
                    buttons: [
                        "ok"
                    ]
                }).then(res => {
                    if (res == "ok") {
                        // 记录当前页面地址并跳转至登录页
                        goToLogin(rootPath);
                    }
                })
            } else {
                // todo: 匿名重置token
            }
        } else if (e.status == 404) {
            // 请求404报错处理
            $msgDialog.error({
                title: $translate.instant("SYSTEM_ERROR_TITLE"),
                content: $translate.instant("SYSTEM_ERROR_CONTENT", { supportmail: envConfig.supportEmail }),
                code: e.status,
                msg: e.config.url
            })
        } else if (e.status == 504) {
            $msgDialog.info({
                title: $translate.instant("NETWORK_CONNECTION_TIMEOUT_TITLE"),
                content: $translate.instant("NETWORK_CONNECTION_TIMEOUT_CONTENT"),
                code: e.status,
                msg: e.config.url
            })
        } else if (e.status == 200) {
            defer.resolve(e.data.data);
        } else if (e.status == -1) {
            $msgDialog.info({
                title: $translate.instant("NETWORK_UNAVAILABLE_TITLE"),
                content: $translate.instant("NETWORK_UNAVAILABLE_CONTENT")
            })
        } else {
            let title: qpLanguage.keys = "UNEXPECTED_ERROR_TITLE";
            let content: qpLanguage.keys = "UNEXPECTED_ERROR_CONTENT";
    
            if (e && e.data && e.data.data) {
                $msgDialog.warning({
                    title: $translate.instant(title),
                    content: $translate.instant(content, { supportmail: envConfig.supportEmail }),
                    code: e.data.data.code,
                    msg: e.data.data.message
                })
            } else if (typeof e === "string") {
                $msgDialog.warning({
                    title: $translate.instant(title),
                    content: $translate.instant(content, { supportmail: envConfig.supportEmail }),
                    code: e,
                    msg: e
                })
            } else {
                $msgDialog.warning({
                    title: $translate.instant(title),
                    content: $translate.instant(content,{ supportmail: envConfig.supportEmail }),
                })
            }
        }
    } else {
        let title: qpLanguage.keys = "UNEXPECTED_ERROR_TITLE";
        let content: qpLanguage.keys = "UNEXPECTED_ERROR_CONTENT";

        if (typeof e === "string") {
            $msgDialog.warning({
                title: $translate.instant(title),
                content: $translate.instant(content,{ supportmail: envConfig.supportEmail }),
                code: e,
                msg: e
            })
        } else {
            $msgDialog.warning({
                title: $translate.instant(title),
                content: $translate.instant(content,{ supportmail: envConfig.supportEmail }),
            })
        }
    }

    return defer.promise;
}

/**
 * @description: 未处理业务请求错误及其他异常sentry手动上报
 * @param {IResponseEvent} e
 * @return {*}
 */
export function sendError(moduleName: string, e: IResponseEvent<IError> | string, params: sendErrParams): void {
    if (params.$injector) {
        if (e == undefined || e == null) {
            return;
        }

        let $logger: ILogger | undefined;

        if (params.$injector.has("$logger")) {
            $logger = params.$injector.get<ILogger>("$logger");
        }

        if ($logger) {
            let err = new Error();

            err.name = moduleName;

            let obj: IErrorConfig = {
                title: "请求接口错误--",
                module: moduleName,
                error: err
            };

            if (typeof e === "string") {
                obj.title = "未知异常--" + e;
            } else if (typeof e === "object") {
                let ctx;

                if (e.config) {
                    ctx = {
                        url: e.config.url,
                        body: e.config.data,
                        params: e.config.params,
                        method: e.config.method,
                    }
                } else {
                    ctx = e;
                }

                if (e.data) {
                    ctx.errCode = e.data?.data?.code;
                }

                obj.title = "请求接口错误--" + (e.data?.data?.message || "");
                obj.context = ctx;
            } else {
                obj.title = "未知异常--" + e;
            }

            $logger.error(obj);
        }
    }
}

export function openUnhandleErrorMsgDialog(msgLevel: IMessageDialogLevel = "info", params: openUnhandleErrorMsgDialogParams): void {
    let $injector = params.$injector;

    let $translate = $injector.get<angular.translate.ITranslateService>("$translate");
    let $msgDialog = $injector.get<IMessageDialog>("qpMessageDialog");

    let title: qpLanguage.keys = "UNEXPECTED_ERROR_TITLE";
    let key: qpLanguage.keys = "UNEXPECTED_ERROR_CONTENT";

    let msgConfigs = {
        title: $translate.instant(title),
        content: $translate.instant(key, { supportmail: envConfig.supportEmail }),
    }

    $msgDialog[msgLevel](msgConfigs);
}


function goToLogin(rootPath: string) {
    let root: string;

    if (rootPath != undefined && rootPath != "") {
        root = rootPath;
    } else {
        root = envConfig.appPath();
    }

    if (root.endsWith("/")) {
        root = root.slice(0, -1);
    }

    window.location.href = root + "/partner/login/" + "?" + encodeURIComponent(location.href);
}